var stickyHeader = {
    scrollHandler: function () {
        var self = this,
            scrollTop = $(window).scrollTop(),
            windowHeight = document.documentElement.clientHeight;

        if ($(document.body).hasClass('disable-sticky-header')) {
            return;
        }

        if (scrollTop > 0) {
            $(document.body).addClass('sticky-header');
        } else {
            $(document.body).removeClass('sticky-header');
        }

        if (scrollTop > windowHeight) {
            $(document.body).addClass('sticky-post-nav');
        } else {
            $(document.body).removeClass('sticky-post-nav');
        }
    },

    init: function () {
        var self = this;

        if ($(document.body).hasClass('hide-sticky-header')) {
            return;
        }

        $(window).on('scroll', function () {
            self.scrollHandler();
        });
    },
};

export { stickyHeader };
